import { render, staticRenderFns } from "./Wiring.vue?vue&type=template&id=5d70eba7&scoped=true"
import script from "./Wiring.vue?vue&type=script&lang=js"
export * from "./Wiring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d70eba7",
  null
  
)

export default component.exports